<style lang="scss">
#mitarbeiterindex {
  .smalltext {
    margin-bottom: 10px;
  }
  .listitem {
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 0px;
    &:nth-child(even) {
      background-color: $c-white;
    }
    position: relative;
    z-index: 1;
    transition: 0.2s all;
    cursor: pointer;

    &:hover {
      z-index: 2;
      //transform: scale(1.01);
      //box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
      background: $c-dark-blue;
      color: #fff;
    }
  }
}
</style>

<template>
  <div id="mitarbeiterindex">
    <Headline :h1="$t('management.title')" />

    <div class="row smalltext">
      <div class="col-4 align-self-center">{{ $t('management.name') }}</div>
      <div class="col-4 align-self-center">{{ $t('management.email') }}</div>
      <div class="col-4 align-self-center">{{ $t('management.unit') }}</div>
    </div>
    <div class="row listitem" :key="worker.id" v-for="worker in workers" @click="navigate(worker.id)">
      <div class="col-4 align-self-center" v-if="worker.lastname != '' || worker.firstname != ''">{{ worker.lastname }} {{ worker.firstname }}</div>
      <div class="col-4 align-self-center" v-else><i>&lt;Kein Name&gt;</i></div>
      <div class="col-4 align-self-center">{{ worker.email }}</div>
      <div class="col-4">
        <i v-if="worker.name == 'Keine Abteilung'">&lt;{{ worker.name }}&gt;</i>
        <span v-else>{{ worker.name }}</span>
        <!-- Abteilungsname-->
      </div>
    </div>

    <!-- <div class="row mt-4">
      <div class="col-3">
        <router-link :to="{ name: 'MitarbeiterNew' }" custom v-slot="{ navigate, isActive, isExactActive }">
          <button :class="{ isActive, isExactActive }" @click="navigate">{{ $t('management.new') }}</button>
        </router-link>
      </div>
    </div> -->
  </div>
</template>

<script lang="ts">
import { useRouter } from 'vue-router';
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();
    const workers = computed(() => store.getters.getWorkers);

    store.dispatch('fetchWorkers');
    const navigate = (id: number) => {
      router.push({ name: 'MitarbeiterEdit', params: { id } });
    };

    return {
      workers,
      navigate,
    };
  },
});
</script>
